var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59509 12C8.59509 10.2051 10.1195 8.75 12 8.75C13.8805 8.75 15.4049 10.2051 15.4049 12C15.4049 13.7949 13.8805 15.25 12 15.25C10.1195 15.25 8.59509 13.7949 8.59509 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C16.2365 20 19.8856 15.7113 21.5364 13.4141C22.1545 12.5538 22.1545 11.4462 21.5364 10.5859C19.8856 8.28871 16.2365 4 12 4C7.76354 4 4.11439 8.28871 2.46363 10.5859C1.84546 11.4462 1.84546 12.5538 2.46363 13.4141C4.11439 15.7113 7.76354 20 12 20ZM12 7.25C14.7484 7.25 16.9764 9.37665 16.9764 12C16.9764 14.6234 14.7484 16.75 12 16.75C9.25161 16.75 7.0236 14.6234 7.0236 12C7.0236 9.37665 9.25161 7.25 12 7.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeAlt);
export default __webpack_public_path__ + "static/media/eye-alt.603f3006341b7be3508b46f98bdaf565.svg";
export { ForwardRef as ReactComponent };